export default __webpack_public_path__ + "static/bestie_background-548da4d0fddf34ce7b4e47e4e244cd54.webp";